import {createSlice} from "@reduxjs/toolkit";

export const invoice = createSlice({
    name: 'invoice',
    initialState: {
        invoiceForm: {
            id: '',
            companyName: '',
            phone: '',
            email: '',
            taxCode: '',
            address: '',
            userAhamoveId: '',
            childAhamoveId: [],
            nationwide: false,
            splitInvoice: false,
            isParent: false,
            status: '',
            parentId: ''
        },

    },
    reducers: {
        setForm: (state, {payload}) => {
            state.invoiceForm[payload.field] = payload.value
        },
        setInvoiceData: (state, {payload}) => {
            state.invoiceForm = {
                id: payload.data['id'],
                companyName: payload.data['company_name'],
                phone: payload.data['phone'],
                email: payload.data['email'],
                taxCode: payload.data['tax_code'],
                address: payload.data['address'],
                userAhamoveId: payload.data['user_id'],
                childAhamoveId: payload.data['user_arr'],
                nationwide: payload.data['is_nation_wide'],
                splitInvoice: payload.data['is_split_invoice'],
                isParent: payload.data['is_parent'],
                status: payload.data['status'],
                parentId: payload.data['parent_id']
            }
        },
        clearForm: (state) => {
            state.invoiceForm = {
                id: '',
                companyName: '',
                phone: '',
                email: '',
                taxCode: '',
                address: '',
                userAhamoveId: '',
                childAhamoveId: [],
                nationwide: false,
                splitInvoice: false,
                isParent: false,
                status: '',
                parentId: ''
            }
        }
    }
})


export const {setForm, setInvoiceData, clearForm} = invoice.actions

export default invoice.reducer
